export default __webpack_public_path__ + "images/th-b6ade2beba225ed5f2b5dc6487ffa54a.svg";